var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"feedback-icon"},[_c('v-icon',{staticClass:"icon",attrs:{"size":"16","color":"white"}},[_vm._v(_vm._s(_vm.iconName))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }